var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_2694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.875 56.4375L31 37.5625C29.6667 39.8125 27.8542 41.6146 25.5625 42.9688C23.2708 44.3229 20.75 45 18 45C13.8333 45 10.2917 43.5417 7.375 40.625C4.45833 37.7083 3 34.1667 3 30C3 27.25 3.67708 24.7292 5.03125 22.4375C6.38542 20.1458 8.1875 18.3333 10.4375 17L4.0625 10.625L7.625 7.125L53.375 52.9375L49.875 56.4375ZM53 22.5L60.5 30L49.0625 41.4375L41.125 33.5625L44.25 31.25L48.75 34.625L53.4375 30L50.9375 27.5H35.0625L30.0625 22.5H53ZM18 40C20.125 40 22.0104 39.4271 23.6562 38.2813C25.3021 37.1354 26.5 35.6458 27.25 33.8125L14.1875 20.75C12.3542 21.5 10.8646 22.6979 9.71875 24.3438C8.57292 25.9896 8 27.875 8 30C8 32.75 8.97917 35.1042 10.9375 37.0625C12.8958 39.0208 15.25 40 18 40ZM18 35C16.625 35 15.4479 34.5104 14.4688 33.5312C13.4896 32.5521 13 31.375 13 30C13 28.625 13.4896 27.4479 14.4688 26.4688C15.4479 25.4896 16.625 25 18 25C19.375 25 20.5521 25.4896 21.5312 26.4688C22.5104 27.4479 23 28.625 23 30C23 31.375 22.5104 32.5521 21.5312 33.5312C20.5521 34.5104 19.375 35 18 35Z",
    fill: "#5776E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOff);
export default __webpack_public_path__ + "static/media/key_off.55326bb36840d15e201f71cc92f85155.svg";
export { ForwardRef as ReactComponent };